/**
 *  Filter array by an element's input value
 *  @param {HTMLElement} element
 *  @param {array} allPlaces
 *  @returns {array} sorted by those that start with the element's input value
 */
export function autocomplete({ element, allPlaces }) {
  //Remove duplicate entries to be part of the location search
  let mapper = {}
  const filtered = allPlaces.filter(place => {
    if(place.data) {
      if(!mapper[place.data.location]) {
        mapper[place.data.location] = true
      } else {
         return false;
      }
    }
    return place.value
      .toLowerCase()
      .includes(element.value.substring(0, element.value.trim().length).toLowerCase());
  });

  const startsWith = [];
  const notStartsWith = [];
  let setMapper = {}
  let uniqueFiltered = filtered.reduce((unique, item) => {
    if(item && item.value && !setMapper[item.value]) {
        if(item.data && item.data.location) {
          if(!setMapper[item.data.location]) {
            unique.push(item);
            setMapper[item.data.location] = true;
          }
        } else {
          unique.push(item);
          setMapper[item.value] = true;
        }
        return unique;
    }
    return unique;
  }, [])
  uniqueFiltered.map(place => {
    if (
      place.value.substring(0, element.value.trim().length).toLowerCase() ===
      element.value.substring(0, element.value.trim().length).toLowerCase()
    ) {
      startsWith.push(place);
    } else {
      notStartsWith.push(place);
    }
  });

  return startsWith.concat(notStartsWith);
}
